import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between" style={{ height: '100px' }}>
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/bf28291cc5d7f0a9c8281f40e0310854/bac760dd5111dec7a1acf46dcaf57f3b.jpeg"
              alt="縦長ジョブ"
              className="h-16 w-auto"
            />
          </Link>
          <Link
            to="/"
            className="text-sm text-gray-600 hover:text-black cursor-pointer flex items-center gap-1"
          >
            <i className="ri-arrow-left-line"></i>
            戻る
          </Link>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-gray-900">プライバシーポリシー</h1>
        
        <div className="prose prose-gray max-w-none">
          <p className="text-gray-700 leading-relaxed mb-8">
            縦長ジョブ（以下「当サイト」といいます。）は、当サイトを利用するユーザーのプライバシーを尊重し、個人情報その他のユーザーに関する情報を適切に取り扱うため、以下のとおりプライバシーポリシーを定めます。
          </p>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">1. 事業者情報</h2>
            <div className="bg-gray-50 rounded-xl p-6">
              <p className="text-gray-700 mb-2"><strong>サイト名：</strong>縦長ジョブ</p>
              <p className="text-gray-700 mb-2"><strong>運営者：</strong>[運営者名]</p>
              <p className="text-gray-700 mb-2"><strong>所在地：</strong>[住所]</p>
              <p className="text-gray-700"><strong>お問い合わせ先：</strong>[メールアドレス]</p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">2. 適用範囲</h2>
            <p className="text-gray-700 leading-relaxed">
              本ポリシーは、当サイトにおいて当サイトが取得するユーザー情報の取扱いに適用されます。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">3. 取得する情報</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              当サイトは、以下の情報を取得することがあります。
            </p>
            
            <h3 className="text-xl font-bold mb-3 text-gray-900">3.1 ユーザーが入力する情報</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              お問い合わせフォーム等を通じてユーザーが入力または送信する氏名、メールアドレス、問い合わせ内容その他の情報
            </p>

            <h3 className="text-xl font-bold mb-3 text-gray-900">3.2 自動的に取得する情報</h3>
            <ul className="list-disc list-inside text-gray-700 leading-relaxed mb-6 space-y-2">
              <li>IPアドレス</li>
              <li>Cookie、端末識別子その他これに類する識別情報</li>
              <li>閲覧したページ、閲覧日時、参照元URL、利用ブラウザ、OS、端末情報</li>
              <li>当サイト内での行動履歴その他アクセス解析に必要な情報</li>
            </ul>

            <h3 className="text-xl font-bold mb-3 text-gray-900">3.3 外部サービスにより取得される情報</h3>
            <p className="text-gray-700 leading-relaxed">
              当サイトでは、TikTokの埋め込み表示その他第三者サービスを利用する場合があります。これらの表示または機能提供に伴い、当該第三者がユーザーに関する情報を取得する場合があります。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">4. 利用目的</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              当サイトは、取得した情報を以下の目的で利用します。
            </p>
            <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-2">
              <li>当サイトの提供、維持、改善のため</li>
              <li>ユーザーからのお問い合わせに対応するため</li>
              <li>不正利用、迷惑行為、利用規約違反への対応のため</li>
              <li>利用状況の分析、品質向上、表示改善のため</li>
              <li>広告配信、広告効果測定またはこれらに関連する最適化のため</li>
              <li>法令等に基づく対応のため</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">5. 第三者提供</h2>
            <p className="text-gray-700 leading-relaxed">
              当サイトは、法令に基づく場合その他法令上認められる場合を除き、ユーザーの個人情報を、本人の同意なく第三者に提供しません。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">6. 外部委託</h2>
            <p className="text-gray-700 leading-relaxed">
              当サイトは、利用目的の達成に必要な範囲で、個人情報の取扱いの全部または一部を外部に委託することがあります。この場合、委託先を適切に選定し、必要かつ適切な監督を行います。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">7. Cookie等の利用</h2>
            <p className="text-gray-700 leading-relaxed">
              当サイトは、利便性向上、利用状況の把握、広告配信その他の目的のため、Cookie等を使用することがあります。ユーザーは、ブラウザ設定によりCookieを無効にすることができます。ただし、その場合、当サイトの一部機能が利用できなくなる場合があります。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">8. アクセス解析・広告配信等</h2>
            <p className="text-gray-700 leading-relaxed">
              当サイトは、アクセス解析ツール、広告配信サービス、埋め込みコンテンツその他の第三者サービスを利用する場合があります。これらのサービス提供者が、Cookie等を通じてユーザー情報を取得、利用する場合があります。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">9. TikTok等の外部コンテンツについて</h2>
            <p className="text-gray-700 leading-relaxed">
              当サイトは、TikTokその他第三者が提供する動画・プロフィール・リンクその他のコンテンツを紹介または埋め込み表示する場合があります。これらの外部コンテンツを閲覧した場合、当該第三者の定める利用規約、プライバシーポリシーその他の条件が適用されることがあります。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">10. 安全管理措置</h2>
            <p className="text-gray-700 leading-relaxed">
              当サイトは、個人情報の漏えい、滅失または毀損の防止その他の個人情報の安全管理のため、必要かつ適切な措置を講じます。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">11. 開示、訂正、利用停止等</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              当サイトは、法令の定めに従い、本人から自己の個人情報について開示、訂正、追加、削除、利用停止等の請求があった場合には、本人確認を行ったうえで、適切に対応します。
            </p>
            <p className="text-gray-700 leading-relaxed">
              請求を希望される場合は、上記お問い合わせ先までご連絡ください。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">12. 未成年者の情報</h2>
            <p className="text-gray-700 leading-relaxed">
              未成年のユーザーは、必要に応じて保護者または法定代理人の同意を得たうえで当サイトを利用するものとします。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">13. ポリシーの変更</h2>
            <p className="text-gray-700 leading-relaxed">
              当サイトは、法令の改正、運営上の必要性その他の理由により、本ポリシーを変更することがあります。変更後の内容は、当サイト上に掲載した時点または別途定める効力発生日から適用されます。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">14. お問い合わせ窓口</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              本ポリシーに関するお問い合わせは、以下までお願いいたします。
            </p>
            <div className="bg-gray-50 rounded-xl p-6">
              <p className="text-gray-700 mb-2"><strong>お問い合わせ先：</strong>[メールアドレス]</p>
              <p className="text-gray-700"><strong>運営者：</strong>縦長ジョブ</p>
            </div>
          </section>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500">制定日：2025年1月1日</p>
            <p className="text-sm text-gray-500">最終改定日：2025年1月1日</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-12 px-4 bg-gray-900 text-white mt-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <img
                src="https://static.readdy.ai/image/bf28291cc5d7f0a9c8281f40e0310854/bac760dd5111dec7a1acf46dcaf57f3b.jpeg"
                alt="縦長ジョブ"
                className="h-48 w-auto mb-4"
              />
              <p className="text-sm text-gray-400">
                縦動画で見つける、新しい仕事との出会い
              </p>
            </div>
            <div>
              <h4 className="font-bold mb-4">サイトマップ</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>
                  <Link to="/" className="hover:text-white cursor-pointer">
                    ホーム
                  </Link>
                </li>
                <li>
                  <Link to="/sessions" className="hover:text-white cursor-pointer">
                    説明会一覧
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="hover:text-white cursor-pointer">
                    プライバシーポリシー
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-4">対象業界</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>飲食</li>
                <li>小売</li>
                <li>物流</li>
                <li>製造</li>
              </ul>
            </div>
          </div>
          <div className="pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
            <p>
              © 2025 縦長ジョブ. All rights reserved. |{' '}
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white cursor-pointer"
              >
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}